import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import * as serviceWorker from './serviceWorker'
import { initFeatureFlags } from './utils/feature-flags'
import './index.css'

initFeatureFlags()

if (process.env.REACT_APP_ENVIRONMENT !== 'development') {
  Sentry.init({
    dsn: 'https://42d4bd2538864f06ba4582652b34c24c@o1092268.ingest.sentry.io/6649721',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    integrations: [new BrowserTracing() as any],
    tracesSampleRate: 1.0,
    environment: process.env.REACT_APP_ENVIRONMENT,
  })
}

ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
